import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoOffice = () => {
  return (
    <g>
      <path d="M10.007 0 1 3.322v9.598l.004.001 3.223-1.284v-7.56l5.835-1.287v11.259l-9.047-1.123L10.007 16 15 14.46V1.607z" />
    </g>
  );
};

export default withIcon(IconLogoOffice);
